module.exports = "/_next/static/images/icon_bundle_7-d31e3eddb374be1551bd8f6ca92fee65.png";